<template>
  <div class="no-mortgage-page">
    <div class="header">
      <img :src="require('@/assets/no-mortgage.svg')" class="margin-top-l" />
    </div>
    <div class="content margin-top-xl padding-horizontal-ml">
      <div class="ri-bold-title">גם במשכנתא, רייזאפ על זה בשבילך.</div>
      <div class="ri-title">
        הטכנולוגיה של רייזאפ תמצא לך את הריביות הטובות ביותר בהתאם לצרכים שלך, ויועץ המשכנתא שלנו ילווה אותך לאורך כל הדרך עד לחסכון!
      </div>
      <riseup-button class="margin-top-xl mortgage-without-data-advisory-chat" title="לייעוץ משכנתא של רייזאפ" color="green"
                     @click="openIntercomMessage" />
      <div class="ri-body margin-top-l footer-text" @click="goToRecycleMortgagePage">יש לי כבר משכנתא, כדאי לי למחזר אותה?</div>
    </div>
  </div>
</template>

<script>
import BaseUI from '@riseupil/base-ui';
import { mapActions, mapGetters, mapState } from 'vuex';
import Segment from '@/Segment';
import router from '@/router';
import config from '@/config';

export default {
  name: 'NoMortgagePage',
  components: {
    RiseupButton: BaseUI.RiseupButton,
  },
  created() {
    Segment.trackUserInteraction('NoMortgagePage_Entered');
    this.setAppHeaderProps({
      backgroundColorVariant: BaseUI.LayoutConsts.COLOR_VARIANT.GREEN,
      textColor: BaseUI.Colors.riseupLightGreen,
      logoColor: BaseUI.Colors.riseupLightGreen,
    });
  },
  computed: {
    ...mapGetters('session', ['householdName']),
    ...mapState('session', ['customerId']),
    ...mapGetters('otsState', ['isInOtsFlow']),
    imageHeaderProps() {
      return {
        backgroundColor: BaseUI.LayoutConsts.COLOR_VARIANT.GREEN,
        bottomSeparator: false,
        // eslint-disable-next-line global-require
        imgSrc: require('@/assets/no-mortgage.svg'),
        textColor: BaseUI.Colors.riseupDarkGreen,
        backgroundPosition: BaseUI.LayoutConsts.BACKGROUND_POSITIONS.BOTTOM_LEFT,
        imgHeight: 360,
      };
    },
  },
  methods: {
    ...mapActions('appHeader', ['setAppHeaderProps']),
    openIntercomMessage() {
      Segment.trackUserInteraction('NoMortgagePage_HearMoreClicked');
      window.open(`${config.get().bookAppointmentUrl}?USERID=${this.customerId}`, '_blank');
    },
    goToRecycleMortgagePage() {
      Segment.trackUserInteraction('NoMortgagePage_GoToRecyclePageClicked');
      if (this.isInOtsFlow) {
        router.push({ path: '/ots/recycle-mortgage' });
      } else {
        router.push({ path: '/recycle-mortgage' });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@riseupil/base-ui/src/scss/riseup-colors";
@import "~@riseupil/base-ui/src/scss/spacings";

.no-mortgage-page {
  height: 100%;
  background: $riseup_beige;
  flex-grow: 1;

  .header {
    display: flex;
    justify-content: center;
    border-radius: 0px 0px 20px 20px;
    background-color: $riseup_green;
  }

  .content {
    text-align: center;
    color: $riseup_dark_green;
  }

  .footer-text {
    color: $riseup_black;
    text-align: center;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
